import { render, staticRenderFns } from "./record-cancel.vue?vue&type=template&id=53ae6983&scoped=true"
import script from "./record-cancel.vue?vue&type=script&lang=js"
export * from "./record-cancel.vue?vue&type=script&lang=js"
import style0 from "./record-cancel.vue?vue&type=style&index=0&id=53ae6983&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ae6983",
  null
  
)

export default component.exports